export const SIMULATOR_RUN_STEPS = [
  {
    key: "scope",
    label: "Scope",
    description: "Choose the broker account, date range, symbol, and candle timeframe.",
  },
  {
    key: "policy",
    label: "Policy",
    description: "Set the run title and action, then structure groups and rules in the policy builder or graph.",
  },
  {
    key: "generate",
    label: "Generate",
    description: "Review your simulation inputs, then run and add results to the comparison list.",
  },
] as const;

export const SIMULATOR_RUN_ACCENT = "#38BBD1";
export const SIMULATOR_RUN_ACCENT_GRADIENT = "linear-gradient(135deg, #38BBD1, #3EEAEC)";
